/**
 * Fixed Type → Domains of Wellness mapping for Senior Center activities.
 * Domain is derived from Type (not independently chosen on import).
 */
export const ACTIVITY_TYPE_OPTIONS = [
  'Game',
  'Health & Wellness',
  'Educational',
] as const;

export type ActivityTypeOption = (typeof ACTIVITY_TYPE_OPTIONS)[number];

export const ACTIVITY_DOMAIN_OPTIONS = [
  'Physical',
  'Social',
  'Intellectual',
  'Emotional',
  'Spiritual',
  'Vocational',
  'Sports',
  'Physical Activities',
] as const;

/** Each activity Type maps to one or more Domains of Wellness. */
export const ACTIVITY_TYPE_DOMAIN_MAP: Record<string, string[]> = {
  Game: ['Physical Activities', 'Sports', 'Social'],
  'Health & Wellness': ['Physical', 'Emotional', 'Spiritual'],
  Educational: ['Intellectual', 'Vocational', 'Social'],
};

export function domainsForActivityType(type: string | null | undefined): string[] {
  const key = String(type ?? '').trim();
  if (!key) {
    return [];
  }
  const exact = ACTIVITY_TYPE_DOMAIN_MAP[key];
  if (exact) {
    return [...exact];
  }
  const matched = Object.keys(ACTIVITY_TYPE_DOMAIN_MAP).find(
    (option) => option.toLowerCase() === key.toLowerCase(),
  );
  return matched ? [...ACTIVITY_TYPE_DOMAIN_MAP[matched]] : [];
}
